<lvr-nav-carousel
	backLabel="Zurück"
	[backLink]="backLink()"
	[carouselElements]="carouselElements()"
	[initialIndex]="currentIndex()"
	(navigation)="onNavigate($event)"
>
</lvr-nav-carousel>

<lvr-heading
	[showEditButton]="canEditClientEnvironments()"
	[showDeleteButton]="canDeleteClientEnvironments()"
	[deleteTranslationKey]="'base.button.delete'"
	(editClicked)="openEdit()"
	(deleteClicked)="openAnonymizationDialog()"
>
	{{ 'client.relatives.details.title' | transloco: { name: name() } }}

	@if (showGhostIcon()) {
		<mat-icon aria-hidden="true" class="material-symbols-outlined" aria-hidden="true" svgIcon="ghost"></mat-icon>
	}
</lvr-heading>

<section class="grid" role="region" aria-labelledby="client-relatives-details-heading">
	<!-- Column 1 -->
	<section>
		<table>
			<tr>
				<th>{{ 'client.relatives.details.last_name' | transloco }}</th>
			</tr>
			<tr>
				<td>{{ relative().lastName }}</td>
			</tr>
			<tr>
				<th>{{ 'client.relatives.details.client_relation' | transloco }}</th>
			</tr>
			<tr>
				<td>
					{{ relative().categoryPersonCategory.name }}<br />
					{{ relative().remark }}
				</td>
			</tr>
			<tr>
				<th>{{ 'client.relatives.details.address' | transloco }}</th>
			</tr>
			<tr>
				<td>
					{{ relative().address?.streetAndHouseNumber }}<br />
					{{ relative().address?.postalCodeAndCity }}
				</td>
			</tr>
			<tr>
				<th>{{ 'base.field.privacy_clarification' | transloco }}</th>
			</tr>
			<tr>
				<td>
					{{ relative().hasBeenClarified ? ('client.relatives.create.privacy_hint_yes' | transloco) : 'Nein' }}<br />
					{{ relative().clarifiedAt | date: dateDisplayFormat }}<br />
					{{ getClarificationLabel(relative().typeOfClarification) }}
				</td>
			</tr>
		</table>
	</section>
	<!-- Column 2 -->
	<section>
		<table>
			<tr>
				<th>{{ 'client.relatives.details.first_name' | transloco }}</th>
			</tr>
			<tr>
				<td>{{ relative().firstName }}</td>
			</tr>
			<tr>
				<th>{{ 'client.relatives.details.legal_guardian' | transloco }}</th>
			</tr>
			<tr>
				<td>
					{{ (relative().isSupervisor ? 'client.relatives.details.yes' : 'client.relatives.details.no') | transloco }}
				</td>
			</tr>
			<tr>
				<th>{{ 'client.relatives.details.preferred_communication' | transloco }}</th>
			</tr>
			<tr>
				<td>
					@for (cp of preferredCommunicationWays(); track cp.id) {
						@if (cp.categoryContactPointId === CONTACT_POINT_TYPE.PHONE) {
							<p>
								<a [href]="'tel:' + cp.contactValue">
									{{ cp.contactValue }}
								</a>
							</p>
						} @else if (cp.categoryContactPointId === CONTACT_POINT_TYPE.EMAIL) {
							<p>
								<a [href]="'mailto:' + cp.contactValue">
									{{ cp.contactValue }}
								</a>
							</p>
						} @else {
							<p>
								{{ cp.contactValue }}
							</p>
						}
						<p>{{ cp.remark }}</p>
					}
				</td>
			</tr>
			<tr>
				<th>{{ 'client.relatives.details.other_communication' | transloco }}</th>
			</tr>
			<tr>
				<td>
					@for (cp of otherCommunicationWays(); track cp.id) {
						@if (cp.categoryContactPointId === CONTACT_POINT_TYPE.PHONE) {
							<p>
								<a [href]="'tel:' + cp.contactValue">
									{{ cp.contactValue }}
								</a>
							</p>
						} @else if (cp.categoryContactPointId === CONTACT_POINT_TYPE.EMAIL) {
							<p>
								<a [href]="'mailto:' + cp.contactValue">
									{{ cp.contactValue }}
								</a>
							</p>
						} @else {
							<p>
								{{ cp.contactValue }}
							</p>
						}
						<p>{{ cp.remark }}</p>
					}
				</td>
			</tr>
		</table>
	</section>
</section>
